export const GET_NETSPEED = 'roasters/GET_NETSPEED';
export const GET_NETSPEED_SUCCESS = 'roasters/GET_NETSPEED_SUCCESS';
export const GET_NETSPEED_FAILED = 'roasters/GET_NETSPEED_FAILED';